import {Alert, Box, Button, Paper, TextField, Typography} from "@mui/material";
import React, {useState} from "react";
import makeStyles from "@mui/styles/makeStyles";
import {Email} from "@mui/icons-material";
import {getAuth, signInWithEmailLink} from "firebase/auth";

const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(4)
    },
    modal: {
        padding: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    page: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        padding: theme.spacing(8),
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "lightgray"
    }
}));

export default function EmailLinkConfirm() {
    const classes = useStyles();
    const auth = getAuth();
    const [signInEmail, setSignInEmail] = useState("");
    const [error, setError] = useState("");
    const handleSignInEmailChange = ({target}: React.ChangeEvent<HTMLInputElement>) => {
        setError("");
        setSignInEmail(target.value);
    }
    const handleSignIn = () => {
        signInWithEmailLink(auth, signInEmail, window.location.href).catch(error => {
            setError("You will need to enter the email that the invitation link was sent to.")
        });
    };

    return (
        <Box className={classes.page}>
            <Paper className={classes.modal}>
                <Typography variant="h4">Flavourworks Pathway Tools</Typography>
                <Typography variant="body1">Please enter your email to continue.</Typography>
                <Box m={1}>
                    <TextField variant="outlined" label="Email" value={signInEmail}
                               autoComplete="email" onChange={handleSignInEmailChange}/>
                </Box>
                <Box m={1}>
                    <Button
                        variant="outlined"
                        disabled={signInEmail === ""}
                        onClick={handleSignIn} startIcon={<Email/>}>Proceed
                    </Button>
                </Box>
                {error && <Alert severity="warning">{error}</Alert>}
            </Paper>
        </Box>
    );
}